<template>
  <div class="modal fade" id="modalAddExpert" tabindex="-1" role="dialog"  aria-hidden="true">
    <div v-if="expertToAdd" class="modal-dialog modal-lg">
      <form v-on:submit="submitExpert">
        <div class="modal-content">
          <div class="color-line"></div>
          <div class="modal-header">
            <h4 class="modal-title">Add Expert informations</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-xs-12">
                <h4>Expert Name</h4>
                <div class="form-group col-xs-6">
                  <label for="firstName" class="required">First Name</label>
                  <input type="" v-model="expertToAdd.firstName" id="firstName" class="form-control" name="firstName"  required>
                  <span v-if="errorFirstName " :class="{'has-error' : errorFirstName , 'has-success' : errorFirstName === false}" class="help-block text-danger">{{ errorFirstName }}</span>
                </div>
                <div class="form-group col-xs-6" >
                  <label for="LastName" class="required">Last name</label>
                  <input type="" v-model="expertToAdd.lastName" id="lastName" class="form-control" name="lastName"  required>
                  <span v-if="errorLastName" :class="{'has-error' : errorLastName , 'has-success' : errorLastName === false}" class="help-block text-danger">{{ errorLastName }}</span>
                </div>
              </div>
              <div class="col-xs-12">
                <h4>Expert Affiliation & Email</h4>
                <div v-for="(affiliation, key) in expertToAdd.author_organisations" v-bind:key="key">
                  <div class="row">
                    <div class="col-md-11 col-xs-10">
                      <div class="form-group col-xs-6">
                        <label for="companyName" class="">Company name</label>
                        <input v-if="affiliation.organisation" type="" v-model="affiliation.organisation.organisationName" id="companyName" class="form-control" name="companyName">
                      </div>
                      <div class="form-group col-xs-6">
                        <label for="email" :class="{required: affiliation.id}">Email</label>
                        <input v-model="affiliation.email" id="email" class="form-control" name="email" :required="affiliation.id">
                        <span v-if="errorEmail && errorEmail[key]" class="help-block text-danger" :class="{'has-error' : errorEmail[key] , 'has-success' : errorEmail === false}">{{ errorEmail[key] }}</span>
                      </div>
                    </div>
                    <div class="col-md-1 col-xs-2" style="margin: 25px 0;">
                      <button v-if="!affiliation.id" class="btn btn-xs btn-outline btn-danger" @click="removeAffiliation($event, key)" ><i class="fa fa-remove"></i> Delete</button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-center" style="margin-top: 10px">
                <button class="btn btn-xs btn-outline btn-success" @click="addAffiliation" ><i class="fa fa-plus"></i>Add</button>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal" >Cancel</button>
            <vue-ladda type="submit" :loading="submit.loading" class="btn btn-info" :data-style="submit.dataStyle">Save Changes</vue-ladda>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>

import vSelect2 from '../../components/utils/select2'
import VueLadda from 'vue-ladda'

export default {
  components: {
    VueLadda,
    vSelect2
  },
  props: ['value', 'listSelected'],
  name: 'AddAuthor',
  watch: {
    value: function (value) {
      this.expertToAdd = value
    }
  },
  methods: {
    submitExpert: function (e) {
      e.preventDefault()
      this.errorFirstName = null
      this.errorLastName = null
      this.errorEmail = null

      if (this.expertToAdd !== null) {
        this.submit.loading = true
        this.axios.post('/expert/', {
          first_name: this.expertToAdd.firstName,
          last_name: this.expertToAdd.lastName,
          author_organisations: this.expertToAdd.author_organisations,
          list_id: this.listSelected.id
        })
          .then((response) => {
            this.submit.loading = false
            this.$eventHub.$emit('updateCompanyAuthorList', true)
            this.expertToAdd = null

            // this.getResources()
            $('#modalAddExpert').modal('hide')
            this.$notify({
              type: 'success',
              title: 'Added !',
              content: 'Expert added to your list ' + this.listSelected.title,
              placement: 'bottom-right'
            })
          }).catch((error) => {
            let errors = error.response.data.errors
            switch (error.response.data.code) {
              case 1:
                this.errorFirstName = errors['first_name'][0]
                break
              case 2:
                this.errorLastName = errors['last_name'][0]
                break
              case 3:
                this.errorEmail = {}
                Object.keys(errors).forEach((error) => {
                  let matches = error.match(/\.(\d)\./)
                  this.errorEmail[matches[1]] = errors[error][0].replace(error, 'email')
                })
                break
            }
            this.submit.loading = false
          })
      }
    },
    addAffiliation: function (event) {
      event.preventDefault()
      if (this.expertToAdd !== null) {
        this.expertToAdd.author_organisations.push({
          organisation: {
            organisationName: null
          },
          country: null,
          email: null
        })
      }
    },
    removeAffiliation: function (event, index) {
      event.preventDefault()
      if (this.expertToAdd !== null) {
        this.expertToAdd.author_organisations.splice(index, 1)
      }
    }
  },
  data () {
    return {
      errorFirstName: null,
      errorLastName: null,
      errorEmail: null,
      submit: {
        loading: false,
        'dataStyle': 'zoom-in'
      },
      expertToAdd: null
    }
  },
  mounted () {
  },
  beforeMount () {
    this.expertToAdd = this.value
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modal/AddAuthor.vue